import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';
import { upgrade as upgradeActions } from '../actions';

export function* upgrade({ payload }) {
  try {
    const res = yield call(api, {
      method: 'post',
      url: URL.UPGRADE,
      data: { priceId: payload },
    });
    yield put(upgradeActions.success(res.data));
    yield put({ type: 'GET_PROFILE_INFO' });
    yield call(toast.success, 'payment was successful');
  } catch (e) {
    yield call(toast.error, e.message);
    yield put(upgradeActions.error(e.message));
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.UPGRADE, upgrade);
}
